import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Mã:", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề:", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Căn cứ đề xuất và ý nghĩa:", -1)
const _hoisted_9 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Mức 1:", -1)
const _hoisted_11 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Mức 2:", -1)
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Mức 3:", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Mức 4:", -1)
const _hoisted_17 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Mức 5:", -1)
const _hoisted_19 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_20 = { class: "p-field p-col-12 p-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center"},
    header: "Thêm tiêu chí đánh giá"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              id: "ma",
              type: "text",
              modelValue: $setup.evalCriteria.ma,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.evalCriteria.ma) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              id: "tieude",
              type: "text",
              modelValue: $setup.evalCriteria.tieu_de,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.evalCriteria.tieu_de) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              id: "cancu",
              type: "text",
              modelValue: $setup.evalCriteria.can_cu,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.evalCriteria.can_cu) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              id: "muc1",
              type: "text",
              modelValue: $setup.evalCriteria.muc1,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.evalCriteria.muc1) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_InputText, {
              id: "muc2",
              type: "text",
              modelValue: $setup.evalCriteria.muc2,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.evalCriteria.muc2) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputText, {
              id: "muc3",
              type: "text",
              modelValue: $setup.evalCriteria.muc3,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.evalCriteria.muc3) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputText, {
              id: "muc4",
              type: "text",
              modelValue: $setup.evalCriteria.muc4,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.evalCriteria.muc4) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_InputText, {
              id: "muc5",
              type: "text",
              modelValue: $setup.evalCriteria.muc5,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.evalCriteria.muc5) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Button, {
              label: "Thêm",
              icon: "pi pi-trash",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.addEval())),
              style: {"font-size":"13px"}
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Button, {
              label: "Thêm mới",
              icon: "pi pi-trash",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.deleteall())),
              style: {"font-size":"13px"}
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}